import { z } from "zod";

/**
 * Weekly opening-hour windows. Weekday 0 = Monday … 6 = Sunday.
 * Clock times are local `HH:MM`. Pickup checkout is gated by these values
 * at submit (`isOpenAt`); cart and menu reads stay available when closed.
 */
export const WeekdaySchema = z.number().int().min(0).max(6);
export const ClockTimeSchema = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/);

export const OpeningWindowSchema = z.object({
  weekday: WeekdaySchema,
  opensAt: ClockTimeSchema,
  closesAt: ClockTimeSchema,
});

export const RestaurantHoursSchema = z.object({
  restaurantId: z.string().min(1),
  windows: z.array(OpeningWindowSchema),
});

export const ReplaceHoursBodySchema = z.object({
  windows: z.array(OpeningWindowSchema),
});

export type Weekday = z.infer<typeof WeekdaySchema>;
export type ClockTime = z.infer<typeof ClockTimeSchema>;
export type OpeningWindow = z.infer<typeof OpeningWindowSchema>;
export type RestaurantHours = z.infer<typeof RestaurantHoursSchema>;
export type ReplaceHoursBody = z.infer<typeof ReplaceHoursBodySchema>;
